import React from 'react'
import { Link } from 'react-router-dom'



export default function Example() {
    return (
        <div className=" flex  md:justify-between flex-col-reverse md:flex-row p-6 rounded-lg shadow-xl">

            <div className='flex flex-row mt-7 md:mt-0 space-x-3'>
                <div className='flex flex-col space-y-3 justify-center '>
                    <img className=' w-24 h-44 rounded-tr-lg rounded-br-lg hover:scale-110' src='https://cdn.shopify.com/s/files/1/0090/4773/6378/files/born-tough-air-pro-mens-steel-gray-gym-workout-shorts-with-legging-liner_1_300x300.jpg?v=154844079968692330' alt='image1'/>
                    <img className=' w-24 h-44 rounded-tr-lg rounded-br-lg  hover:scale-110' src='https://i.pinimg.com/originals/67/f4/a8/67f4a82ccc94236584936d40d29cd41f.jpg' alt='image2'/>
                </div>
                <div className='flex flex-col space-y-3 '>
                    <img className=' w-24 h-44 rounded-b-lg hover:scale-110' src='https://i8.amplience.net/i/jpl/jd_362499_c?qlt=92&w=600&h=765&v=1&fmt=auto' alt='image3'/>
                    <img className=' w-24 h-44 rounded-lg hover:scale-110' src='https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/777fdf9a-52d8-4b79-bffe-68dabe65f5a9/fc-barcelona-2021-22-stadium-third-dri-fit-football-shirt-hfkmkt.png' alt='image4'/>
                    <img className=' w-24 h-44 rounded-t-lg hover:scale-110' src='https://img.fcbayern.com/image/upload/q_auto,f_auto/w_800,h_1067,c_pad/eCommerce/produkte/30616_3/fc-bayern-trikot-away-22-23.png' alt='image5'/>
                </div>
                <div className='flex flex-col space-y-3 justify-center '>
                    <img className=' w-24 h-44 rounded-tl-lg rounded-bl-lg hover:scale-110' src='https://www.gqmiddleeast.com/public/styles/full_img_sml/public/images/2019/10/01/Gym_Clothes_Men_GQME_8.jpg' alt='image6'/>
                    <img className=' w-24 h-44 rounded-tl-lg rounded-bl-lg hover:scale-110' src='https://i.pinimg.com/736x/8e/71/f4/8e71f46bca62323f9b3c069409aa67cd.jpg' alt='image7'/>
                </div>
            </div>

            <div className="flex flex-col items-end  justify-center ">
                <h1 className="text-4xl text-right font font-extrabold tracking-tight text-chwaram drop-shadow-lg sm:text-6xl">
                    ناوازەکان بەردەستن
                </h1>
                <p className="mt-4 text-xl text-right text-slate-900">
                    کاڵای وەرزشی نایاب و کوالێتیت پێویستە!!؟ ئێستا بێ دوودڵی سەردانی بەشی کاڵا کان بکەو باشترینەکان لەوێ هەڵبژێرە
                </p>
                <Link to='/sport' className="mt-7 shadow-sm shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-52 overflow-hidden text-sm font-medium text-chwaram rounded-lg group bg-gradient-to-br from-penjam to-chwaram group-hover:from-penjam group-hover:to-chwaram hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                    <span className=" text-center shadow-sm shadow-penjam relative w-52 px-5 py-2.5 transition-all ease-in duration-75 bg-yakam  rounded-md group-hover:bg-opacity-0">
                        کاڵاوەرزشیەکان
                    </span>
                </Link>
            </div>
        </div>
    )
}

